'use client';

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from './cn';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      {...props}
    >
      <div
        className="font-quicksand text-lg leading-[140%] font-semibold text-[#111]"
        style={{
          fontVariantNumeric: 'slashed-zero',
          fontFeatureSettings: "'ss01' on",
        }}
      >
        {props.children}
      </div>
    </LabelPrimitive.Root>
  );
}

export { Label };
